import { AfterContentInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { SideNavItemComponent } from '../side-nav-item/side-nav-item.component';

const SIDE_NAV_EXPANDED_STATE_KEY = 'tw-side-nav-expanded-state';

type SideNavStates = 'expanded' | 'collapsed';

@Component({
  selector: 'twaice-fe-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  standalone: false,
})
export class SideNavComponent implements AfterContentInit {
  @Input() expandable = false;
  @Input() perserveExpandedState = false;
  state: SideNavStates = 'collapsed';

  @ContentChildren(SideNavItemComponent) items: QueryList<SideNavItemComponent>;

  ngAfterContentInit(): void {
    if (this.perserveExpandedState) {
      this.state = (localStorage.getItem(SIDE_NAV_EXPANDED_STATE_KEY) as SideNavStates) ?? this.state;
      this.toggleExpand(this.state);
    }
  }

  toggleExpand(newState: SideNavStates): void {
    this.state = newState;
    this.items.forEach((item) => (item.expanded = this.state === 'expanded'));
    if (this.perserveExpandedState) {
      localStorage.setItem(SIDE_NAV_EXPANDED_STATE_KEY, this.state);
    }
  }
}
